import { ToggleSwitch } from '../../';
import { TogglePrivacyOption } from '../user-privacy-settings/user-privacy-settings';
import { Status } from '@breakroom-nx/helpers';

import {
  openModal,
  useAppDispatch,
  useUpdatePrivacySettingsMutation,
} from '@breakroom-nx/redux';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';

/* eslint-disable-next-line */
export interface UserPrivacySwitchProps {
  title: string;
  description: string;
  privacyOption: TogglePrivacyOption;
  on?: boolean;
  disabled?: boolean;
}

export function UserPrivacySwitch({
  title,
  description,
  privacyOption,
  on = false,
  disabled = false,
}: UserPrivacySwitchProps) {
  const dispatch = useAppDispatch();
  const [updatePrivacySettings, updatedData] =
    useUpdatePrivacySettingsMutation();

  async function updatePrivacyState(
    privacyOption: TogglePrivacyOption,
    turnOn: boolean
  ) {
    await updatePrivacySettings({
      privacyOption: privacyOption,
      turnOn: turnOn,
    }).catch(() => {
      dispatch(
        openModal({
          modalType: 'Alert',
          modalProps: {
            status: Status.error,
            title: 'There was an error updating your privacy settings',
            description: 'Please try again.',
          },
        })
      );
    });
  }

  return (
    <ToggleSwitch
      title={title}
      description={description}
      on={on}
      isLoading={updatedData.status === QueryStatus.pending}
      disabled={disabled || updatedData.status === QueryStatus.pending}
      onToggle={() => {
        updatePrivacyState(privacyOption, !on);
      }}
      key={'name'}
    />
  );
}

export default UserPrivacySwitch;
